module.exports = __webpack_public_path__ + "adb87e83335d62212638fd04e3c513f9.homes.svg";